<template>
    <div>
        <div class="text-center p-10 max-w-[500px] mx-auto">
            <!-- Page content -->
            <div>
                <!-- Company logo -->
                <img class="h-[50px] mx-auto mb-10" :src="$companyTool.confFile().style.logo">

                <div class="bg-green-200 p-6 rounded text-green-900">
                    <div class="text-lg font-bold border-b pb-4 mb-4 border-green-900">{{ $tt('La photo a été envoyée') }}</div>
                    <div class="text-sm">{{ $tt('Merci de continuer de saisir votre dossier sur ordinateur') }}</div>
                </div>
            </div>
        </div>
        <!-- Langs -->
        <div class="fixed bottom-7 left-0 right-0" v-if="langage && $companyTool.confFile().translates">
            <div class="flex items-center justify-around">
                <div @click="changeLangage(lang.lang)" v-for="(lang, langIndex) in langs" :key="'menu-lang-' + langIndex" style="text-decoration: none">
                    <img class="h-[15px] cursor-pointer hover:opacity-50 duration-200" :src="lang.logo" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    data() {
        return {
            file: null,
            langage: null,
            langs: null,
        }
    },
    methods: {
        changeLangage(lang) {
            localStorage.setItem('langage', lang)
            location.reload()
        },
        async getAllLang() {
            let response = await apiService.post('getalllang', {})
            this.langs = response.data.posts.post
        },
    },

    async mounted() {
        // Lang
        await this.getAllLang()
        const lang = await this.$companyTool.getLang()
        this.langage = lang
    }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/companies/default/views/form/TakePictureSuccess.vue